<template>
  <div>
    <b-tabs card pills lazy>
      <b-tab :title="$t('Archives')" ref="Archive">
        <table-manager
        @filterChanged="filterChanged"
        @paginationChanged="paginationChanged"
        @ClickOnAddButton="showAdd"
        @ClickOnCheckButton="check"
        @ClickOnVerifyButton="verify"
        @ClickOnMakeArchive="makeArchive"
        :options="options" />
        <basic-table
          v-if="archiveDB"
          :items="archiveDB"
          :fields="archiveDBFields"
          :filter="filter"
          :perPage="perPage"
          :currentPage="currentPage"
          v-model="totalRows"/>
        <table-manager-bottom
          :totalRows="totalRows" :perPage="perPage"
          v-model="currentPage"/>
      </b-tab>

      <b-tab :title="$t('Archives scheduled')" ref="ArchiveScheduled">
        <table-manager
        @ClickOnAddButton="showSchedAdd"
        :options="optionsScheduled"/>
        <basic-table
          :isDelete="true"
          @ClickOnDeleteButton="clickOnDeleteScheduled"
          :items="archiveDBScheduled"
          :fields="archiveDBScheduledFields"  />
      </b-tab>
    <b-tab :title="$t('Settings')">
      <b-form-group label-align="left" :label="$t('Archive database name')" label-cols="4">
        <b-form-input
        @update="(val)=>{registryArchiveName=val}"
        v-model="archiveDbName[0].raw_values[0].value"/>
      </b-form-group>
      <b-form-group label-align="left" :label="$t('Archive database connection string')" label-cols="4">
        <b-form-textarea @update="(val)=>{registryArchiveConnection=val}" v-model="archiveDbConnection[0].raw_values[0].value"  rows="4"/>
        <b-input-group-append >
          <i class="primary fa fa-light fa-question "
          v-b-tooltip.hover :title="$i18n.t('tooltip_archive_db_connection_extended')"
          style="margin-left:0.1rem;margin-right:0.2rem;margin-top:0.65rem"/>
        </b-input-group-append>
        <md-button
          style="margin-left:-9.6rem; margin-top: -8.2rem;"
          size="sm" @click.stop="testConn" class="md-raised">{{ $t('Test connection') }}</md-button>
      </b-form-group>
      <modal-ok-cancel @save="saveRegistry()" size="md"/>
    </b-tab>
    </b-tabs>

    <b-modal hide-footer size="md" :title="$t('Scheduled archive settings')" ref="Settings">
    <div :key="rerenderAddScheduler">
      <b-form-group label-align="left" :label="$t('Name')" label-cols="4">
        <b-form-input v-model="archive.name"/>
      </b-form-group>
      <b-form-group label-align="left" :label="$t('Scheduler')" label-cols="4">
        <b-form-select @change="changeArchiveType" v-model="archive.type" :options="archiveScheduler"/>
      </b-form-group>
      <b-form-group v-if="isCustomDuration" label-align="left" :label="$t('Custom archive duration')" label-cols="4">
        <b-form-input type="number" v-model="archive.custom_duration"/>
        <b-input-group-append>
            <span id="tooltip">
              <b-img :src="questionImage"/>
            </span>
            <b-tooltip target="tooltip" triggers="hover">
              {{ $t('Execution plan: now then every custom duration') }}
            </b-tooltip>
          </b-input-group-append>
      </b-form-group>
      <b-form-group v-if="!isCustomDuration" label-align="left" :label="$t('Run date')" label-cols="4">
        <b-row>
          <b-col class="margin-left:25rem">
            <i>{{ $t('Day:') }}</i>
            <b-form-select size="sm" class="mt-3"  v-model="archive.day" :options="days"/>
          </b-col>
          <b-col>
            <i>{{ $t('Time:') }}</i>
            <b-form-input
              style="margin-top: 0.95rem; height: 2rem;"
              v-model="archive.time"
              type="text"
              placeholder="15:31:00"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group
          label-align="left" :label="$t('Use connection')" label-cols="4">
      <b-row>
        <b-col>
          <b-form-checkbox
           style="margin-left: 0.1rem;margin-top: 1rem;"
           switch v-model="archive.use_connection"/>
        </b-col>
        <b-col >
          <md-button
          style="margin-left:-1.5rem; margin-top: 0.5rem;"
          size="sm" @click.stop="testConn" class="md-raised">{{ $t('Test connection') }}</md-button>
        </b-col>
        <b-col>
          <i class="primary fa fa-link fa-xl"
          v-b-tooltip.hover :title="archiveDbConnection[0].raw_values[0].value === '' ? $t('Connection is empty') : archiveDbConnection[0].raw_values[0].value"
          style="margin-left:0.1rem;margin-right:0.2rem;margin-top:1rem"/>
        </b-col>
      </b-row>
    </b-form-group>

      <modal-ok-cancel @save="saveSchdule()" @cancel="hideSchedule()" size="md"/>
    </div>
    </b-modal>

  </div>
</template>

<script>
export default {
  data () {
    return {
      questionImage: require('@/assets/img/question.png'),
      rerenderAddScheduler: 0,
      isCustomDuration: false,
      registryArchiveName: '',
      registryArchiveConnection: '',
      timeValidation: /^\d\d:\d\d:\d\d$/,
      archiveDBFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'begin', label: this.$i18n.t('Start time'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'end', label: this.$i18n.t('End time'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'status', label: this.$i18n.t('Status'), sortable: true},
        {key: 'is_scheduled', label: this.$i18n.t('Is scheduled'), sortable: true},
        {key: 'use_connection', label: this.$i18n.t('Use connection'), sortable: true}
      ],
      archiveDBScheduledFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'run_date', label: this.$i18n.t('Run date'), sortable: true, formatter: (val, key, item) => { return this.$root.getMomentWithTZDelta(val).format('DD-MM-YYYY HH:mm:ss') }},
        {key: 'type', label: this.$i18n.t('Type'), sortable: true, formatter: (val, key, item) => { return this.typeString(val) }},
        {key: 'use_connection', label: this.$i18n.t('Use connection'), sortable: true},
        {key: 'actions', label: 'Actions'}
      ],
      options: {
        isShowMakeArchive: true,
        isShowAddButton: false,
        isShowCheckButton: true,
        isShowVerifyButton: true
      },
      optionsScheduled: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      weekly: 0,
      monthly: 1,
      quarter: 2,
      halfYear: 4,
      year: 8,
      archive: {
        'name': '',
        'type': 1,
        'day': 1,
        'time': '12:00:00',
        'use_connection': false,
        'custom_duration': 0
      },
      archiveEmpty: {
        'name': '',
        'type': 1,
        'day': 1,
        'time': '12:00:00',
        'use_connection': false,
        'custom_duration': 0
      },
      archiveScheduler: [
        {text: this.$i18n.t('Custom'), value: 16},
        {text: this.$i18n.t('Monthly'), value: 1},
        {text: this.$i18n.t('Quarterly'), value: 2},
        {text: this.$i18n.t('Half-yearly'), value: 4},
        {text: this.$i18n.t('Yearly'), value: 8}
      ],
      days: [
        {text: 1, value: 1},
        {text: 2, value: 2},
        {text: 3, value: 3},
        {text: 4, value: 4},
        {text: 5, value: 5},
        {text: 6, value: 6},
        {text: 7, value: 7},
        {text: 8, value: 8},
        {text: 9, value: 9},
        {text: 10, value: 10},
        {text: 11, value: 11},
        {text: 12, value: 12},
        {text: 13, value: 13},
        {text: 14, value: 14},
        {text: 15, value: 15},
        {text: 16, value: 16},
        {text: 17, value: 17},
        {text: 18, value: 18},
        {text: 19, value: 19},
        {text: 20, value: 20},
        {text: 21, value: 21},
        {text: 22, value: 22},
        {text: 23, value: 23},
        {text: 24, value: 24},
        {text: 25, value: 25},
        {text: 26, value: 26},
        {text: 27, value: 27},
        {text: 28, value: 28}
      ]
    }
  },
  methods: {
    changeArchiveType () {
      if (this.archive.type === 16) {
        this.isCustomDuration = true
        this.rerenderAddScheduler += 1
      } else {
        this.isCustomDuration = false
      }
    },
    showSchedAdd () {
      this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 7, object_id: 0})
      this.archive = JSON.parse(JSON.stringify(this.archiveEmpty))
      this.$refs.Settings.show()
    },
    testConn () {
      if (this.archiveDbConnection[0].raw_values[0].value.length === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Connection string is empty'), 'Error')
        return
      }
      this.$store.dispatch('Settings/TEST_DB_CONN', {connection: this.archiveDbConnection[0].raw_values[0].value}).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t(response.data.error), 'Error')
        } else {
          this.$root.$emit('makeToasts', 'success', this.$i18n.t('Connection is opened successfully'), this.$i18n.t('Success'))
        }
      })
    },
    saveRegistry () {
      let tmp = JSON.parse(JSON.stringify(this.archiveDbName[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = this.registryArchiveName
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      tmp = JSON.parse(JSON.stringify(this.archiveDbConnection[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = this.registryArchiveConnection
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 7, object_id: 0})
    },
    clickOnDeleteScheduled (item) {
      this.$store.dispatch('Settings/DELETE_ARCHIVE_DB_SCHEDULE', item.id)
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB_SCHEDULE')
    },
    typeString (type) {
      switch (type) {
        case 1:
          return this.$i18n.t('Monthly')
        case 2:
          return this.$i18n.t('Quarter')
        case 4:
          return this.$i18n.t('Half yearly')
        case 8:
          return this.$i18n.t('Yearly')
        case 16:
          return this.$i18n.t('Custom')
      }
    },
    saveSchdule () {
      if (!(this.timeValidation.test(this.archive.time))) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Time has invalid format'), 'Error')
        return
      }
      let time = this.archive.time.split(':')
      this.archive.hour = Number(time[0])
      this.archive.min = Number(time[1])
      this.archive.sec = Number(time[2])
      this.archive.custom_duration = Number(this.archive.custom_duration)
      let offet = (new Date().getTimezoneOffset()) * 60
      this.archive.gmt_offset = localStorage.getItem('selectedOffset-local') === '0' ? Number(-1 * offet) : Number(localStorage.getItem('selectedOffset-local'))
      this.$store.dispatch('Settings/CREATE_ARCHIVE_DB_SCHEDULE', this.archive).then(result => {
        if (result.status === 200) {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB_SCHEDULE')
        } else {
          this.archive.name = ''
          this.archive.type = this.monthly
          this.archive.connection = ''
        }
      })
      this.setArchiveDefault()
      this.$refs.Settings.hide()
    },
    hideSchedule () {
      this.setArchiveDefault()
      this.$refs.Settings.hide()
    },
    setArchiveDefault () {
      this.archive = {
        'name': '',
        'type': 1,
        'day': 1,
        'time': '12:00:00',
        'use_connection': false
      }
    },
    check () {
      let response = this.$store.dispatch('Settings/UPDATE_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    verify () {
      let response = this.$store.dispatch('Settings/VERIFY_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    makeArchive (type) {
      let response
      switch (type) {
        case 'local':
          response = this.$store.dispatch('Settings/CREATE_ARCHIVE_DB')
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
              this.$root.$emit('makeToasts')
            }
          })
          break
        case 'remote':
          response = this.$store.dispatch('Settings/CREATE_ARCHIVE_DB_REMOTE')
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
              this.$root.$emit('makeToasts')
            }
          })
      }
    },
    showAdd () {
      let response = this.$store.dispatch('Settings/CREATE_ARCHIVE_DB')
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ARCHIVE_DB')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  watch: {
    archiveDbConnection: function (val) {
      this.registryArchiveConnection = val[0].raw_values[0].value
    },
    archiveDbName: function (val) {
      this.registryArchiveName = val[0].raw_values[0].value
    }
  },
  computed: {
    archiveDbName () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'archive_db_name'
      })
    },
    archiveDbConnection () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'archive_db_connection'
      })
    },
    archiveDBScheduled () {
      return this.$store.getters['Settings/ARCHIVE_DB_SCHEDULE']
    },
    archiveDB () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/ARCHIVE_DB']))
      for (let el of copy) {
        switch (el.status) {
          case 0:
            el.status = 'OK'
            break
          case 1:
            el.status = this.$i18n.t('Repair required')
            break
          case 2:
            el.status = this.$i18n.t('Unable to repair')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_ARCHIVE_DB_SCHEDULE')
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 7, object_id: 0})
    this.$store.dispatch('Settings/GET_ARCHIVE_DB')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/archiveDB/main.vue